<!-- 创建用车订单弹框 -->
<template>
    <el-dialog append-to-body @close="dialogClose" ref="dialog" :show-close="false" :visible.sync="dialogVisible"
        width="35%">
        <div class="main" v-loading="loading">
            <div class="detail">
                <div class="detail_box" v-for="(items, indexs) in dataArr" :key="indexs">
                    <div class="data">
                        <p class="data_p2">D{{ items.planDay }}</p>
                        <p class="data_p1">{{ items.planDate }} {{ items.planCity }}</p>
                    </div>
                    <div v-for="(item, index) in items.orderSurePlanResultList" :key="index">
                        <div class="title">{{ item.budgetDetail.budget.resourceNameCn ?
                            item.budgetDetail.budget.resourceNameCn :
                            item.budgetDetail.budget.resourceNameEn }}</div>
                        <div class="detail_list">
                            <div class="detail_list_t">
                                <el-tooltip
                                    :content="item.budgetDetail.stockDetail.budgetType + item.budgetDetail.stockDetail.mealText"
                                    placement="top" effect="light">
                                    <p class="detail_list_t_p3">{{
                                        item.budgetDetail.stockDetail.budgetType }}+{{
        item.budgetDetail.stockDetail.mealText
    }}
                                    </p>
                                </el-tooltip>
                                <p class="detail_list_t_p1">{{ item.budgetDetail.productName }}</p>
                                <el-tooltip :content="item.budgetDetail.stockDetail.productDesc" placement="top"
                                    effect="light">
                                    <p class="detail_list_t_p3">{{ item.budgetDetail.stockDetail.productDesc }}</p>
                                </el-tooltip>
                                <p>{{ item.budgetDetail.ratio }}{{ item.budgetDetail.currency }}/{{
                                    item.budgetDetail.timeUnit
                                }}/{{
    item.budgetDetail.quantityUnit }}</p>
                                <p>{{ item.budgetDetail.stockNumber }}{{ item.budgetDetail.quantityUnit }}</p>
                                <p class="detail_list_t_p2">{{ item.budgetDetail.stockNumber *
                                    Number(item.budgetDetail.ratio) }}{{ item.budgetDetail.currency }}</p>
                            </div>
                            <div class="detail_list_b">
                                <div class="detail_list_b_l">
                                    <p class="detail_list_b_l_p1">行程</p>
                                    <el-popover v-if="maintenanceData !== '{}'" v-model="item.visible" ref="popoverRef"
                                        placement="right-start" width="425" trigger="manual">
                                        <span @click="maintenance(item)" slot="reference"
                                            class="detail_list_b_l_span1" v-if="!detection">维护</span>
                                        <div class="edit">
                                            <svg-icon @click="save"
                                                style="margin-right: 0.05rem;cursor: pointer;height: 0.17rem;position: absolute;right: 0.2rem;top: 0;"
                                                iconClass="file"></svg-icon>
                                            <svg-icon @click="closePopover(item)"
                                                style="cursor: pointer;height: 0.25rem;position: absolute;right: 0;top: -0.05rem;"
                                                iconClass="close"></svg-icon>
                                            <div class="edit_prompt">
                                                <p class="edit_prompt_p1">详细用车行程维护</p>
                                                <p class="edit_prompt_p2">鼠标点击单独产品上即可维护接送及途径地点</p>
                                            </div>
                                            <div class="edit_detail" v-if="maintenanceData !== '{}'">
                                                <div  class="detail_list_b_block" v-for="(n, m) in maintenanceData.meetList"
                                                    :key="'meetList' + m">
                                                    <div @click="editPlan(n)" class="detail_list_b_r_yuan">
                                                        接
                                                    </div>
                                                    <p @click="editPlan(n)" style="cursor: pointer;" class="detail_list_b_r_p1">{{ n.resourceNameCn }}</p>
<!--                                                    <el-popover ref="popoverRef" placement="top" trigger="hover">-->
<!--                                                        <p slot="reference" style="cursor: pointer;"-->
<!--                                                            class="detail_list_b_r_p1">-->
<!--                                                            {{ n.resourceNameCn }}</p>-->
<!--                                                        <div-->
<!--                                                            style="display: flex;align-items: center;justify-content: center;">-->
<!--                                                            <div :class="n.mode == a.code ? 'active2' : 'active1'"-->
<!--                                                                class="detail_list_b_r_yuan" v-for="(a) in btnType"-->
<!--                                                                :key="a.code">-->
<!--                                                                {{ a.name }}-->
<!--                                                            </div>-->
<!--                                                            <el-date-picker value-format="timestamp" size="small"-->
<!--                                                                style="width: 1.8rem;" v-model="n.startTime" type="datetime"-->
<!--                                                                placeholder="抵达时间">-->
<!--                                                            </el-date-picker>-->
<!--                                                        </div>-->
<!--                                                    </el-popover>-->
                                                </div>
                                                <div class="detail_list_b_block" v-for="(n, m) in maintenanceData.tuList"
                                                    :key="'tuList' + m">
                                                    <p @click="editPlan(n)"
                                                       style="cursor: pointer;display: flex;align-items: center;"
                                                       class="detail_list_b_r_p1">
                                                        <svg-icon style="margin-right: 0.05rem;" iconClass="car"
                                                                  :systemColor="'#7D7D7D'"></svg-icon> {{ n.resourceNameCn }}
                                                    </p>
<!--                                                    <el-popover ref="popoverRef" placement="top" trigger="hover">-->
<!--                                                        <p slot="reference"-->
<!--                                                            style="cursor: pointer;display: flex;align-items: center;"-->
<!--                                                            class="detail_list_b_r_p1">-->
<!--                                                            <svg-icon style="margin-right: 0.05rem;" iconClass="car"-->
<!--                                                                :systemColor="'#7D7D7D'"></svg-icon> {{ n.resourceNameCn }}-->
<!--                                                        </p>-->
<!--                                                        <div-->
<!--                                                            style="display: flex;align-items: center;justify-content: center;">-->
<!--                                                            <div :class="n.mode == a.code ? 'active2' : 'active1'"-->
<!--                                                                class="detail_list_b_r_yuan" v-for="(a) in btnType"-->
<!--                                                                :key="a.code">-->
<!--                                                                {{ a.name }}-->
<!--                                                            </div>-->
<!--                                                            <el-date-picker value-format="timestamp" size="small"-->
<!--                                                                style="width: 1.8rem;" v-model="n.startTime" type="datetime"-->
<!--                                                                placeholder="抵达时间">-->
<!--                                                            </el-date-picker>-->
<!--                                                        </div>-->
<!--                                                    </el-popover>-->
                                                </div>
                                                <div v-for="(n, m) in maintenanceData.giveList" :key="'giveList' + m" class="detail_list_b_block">
                                                    <div @click="editPlan(n)" class="detail_list_b_r_yuan">
                                                        送
                                                    </div>
                                                    <p @click="editPlan(n)" style="cursor: pointer;"
                                                       class="detail_list_b_r_p1">
                                                        {{ n.resourceNameCn }}
                                                    </p>
<!--                                                    <el-popover v-for="(n, m) in maintenanceData.giveList"-->
<!--                                                        :key="'giveList' + m" ref="popoverRef" placement="top"-->
<!--                                                        trigger="hover">-->
<!--                                                        <p slot="reference" style="cursor: pointer;"-->
<!--                                                            class="detail_list_b_r_p1">-->
<!--                                                            {{ n.resourceNameCn }}</p>-->
<!--                                                        <div-->
<!--                                                            style="display: flex;align-items: center;justify-content: center;">-->
<!--                                                            <div :class="n.mode == a.code ? 'active2' : 'active1'"-->
<!--                                                                class="detail_list_b_r_yuan" v-for="(a) in btnType"-->
<!--                                                                :key="a.code">-->
<!--                                                                {{ a.name }}-->
<!--                                                            </div>-->
<!--                                                            <el-date-picker value-format="timestamp" size="small"-->
<!--                                                                style="width: 1.8rem;" v-model="n.startTime" type="datetime"-->
<!--                                                                placeholder="抵达时间">-->
<!--                                                            </el-date-picker>-->
<!--                                                        </div>-->
<!--                                                    </el-popover>-->
                                                </div>
                                            </div>
                                            <div class="edit_other">
                                                <p class="edit_other_p1">添加行程轴外的</p>
                                                <el-radio-group v-model="radio">
                                                    <!-- <el-radio :label="0">地址</el-radio> -->
                                                    <el-radio :label="0">酒店</el-radio>
                                                    <el-radio :label="2">景点</el-radio>
                                                    <el-radio :label="15">航班</el-radio>
                                                    <el-radio :label="4">餐厅</el-radio>
                                                </el-radio-group>
                                            </div>
                                            <div class="edit_other_detail" v-for="(n, m) in initOtherData[radio]" :key="m">
                                                <i @click="addOther" v-if="m === initOtherData[radio].length - 1"
                                                    class="el-icon-circle-plus-outline edit_other_detail_del"></i>
                                                <i @click="delOther(m)" v-else
                                                    class="el-icon-remove-outline edit_other_detail_del"></i>
                                                <div v-if="radio == 15">
                                                    <div class="edit_other_detail_t">
                                                        <div class="edit_other_detail_t_yuan_box">
                                                            <div @click="handlerSwClick(n, a.code)"
                                                                :class="n.mode == a.code ? 'active2' : 'active1'"
                                                                class="edit_other_detail_t_yuan" v-for="(a) in btnType"
                                                                :key="a.code">
                                                                {{ a.name }}
                                                            </div>
                                                        </div>
                                                        <el-input size="small" v-model="n.resourceNameCn"
                                                            placeholder="请输入航班号、起飞机场、降落机场"></el-input>
                                                    </div>
                                                    <div class="edit_other_detail_b">
                                                        <div class="edit_other_detail_b_l">
                                                            <div class="edit_other_detail_b_l_div">
                                                                <p>起飞时间</p>
                                                                <p style="font-size: 0.12rem;">(本地时间)</p>
                                                            </div>
                                                            <el-date-picker value-format="timestamp" size="small"
                                                                style="width: 1.8rem;" v-model="n.startTime" type="datetime"
                                                                placeholder="选择时间">
                                                            </el-date-picker>
                                                        </div>
                                                        <div class="edit_other_detail_b_l">
                                                            <div class="edit_other_detail_b_l_div">
                                                                <p>降落时间</p>
                                                                <p style="font-size: 0.12rem;">(本地时间)</p>
                                                            </div>
                                                            <el-date-picker value-format="timestamp" size="small"
                                                                style="width: 1.8rem;" v-model="n.endTime" type="datetime"
                                                                placeholder="选择时间">
                                                            </el-date-picker>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="edit_other_detail_t">
                                                        <div class="edit_other_detail_t_yuan_box">
                                                            <div @click="handlerSwClick(n, a.code)"
                                                                :class="n.mode == a.code ? 'active2' : 'active1'"
                                                                class="edit_other_detail_t_yuan" v-for="(a) in btnType"
                                                                :key="a.code">
                                                                {{ a.name }}
                                                            </div>
                                                        </div>
                                                        <el-input size="small" v-model="n.resourceNameCn"
                                                            :placeholder="'请输入' + selectType[radio]"></el-input>
                                                    </div>
                                                    <div class="edit_other_detail_b">
                                                        <el-time-picker @input="selectTime($event,items.planDate,n)" :value="n.startTime" value-format="HH:mm" format="HH:mm" placeholder="抵达时间" ></el-time-picker>
                                                        <el-input size="small" v-model="n.remark"
                                                            placeholder="如有您需要备注的请在此处输入"></el-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="detail_list_b_r">
                                    <div class="detail_list_b_block" v-for="(n, m) in item.meetList" :key="'meetList' + m">
                                        <div class="detail_list_b_r_yuan">
                                            接
                                        </div>
                                        <p class="detail_list_b_r_p1">{{ n.resourceNameCn ? n.resourceNameCn :
                                            n.resourceNameEn }}</p>
                                    </div>
                                    <div class="detail_list_b_block" v-for="(n, m) in item.tuList" :key="'tuList' + m">
                                        <svg-icon style="margin-right: 0.05rem;" iconClass="car"
                                            :systemColor="'#7D7D7D'"></svg-icon>
                                        <p class="detail_list_b_r_p1">{{ n.resourceNameCn ? n.resourceNameCn :
                                            n.resourceNameEn }}</p>
                                    </div>
                                    <div class="detail_list_b_block" v-for="(n, m) in item.giveList" :key="'giveList' + m">
                                        <div class="detail_list_b_r_yuan">
                                            送
                                        </div>
                                        <p class="detail_list_b_r_p1">{{
                                            n.resourceNameCn ? n.resourceNameCn : n.resourceNameEn }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_btn_box">
            <el-button type="primary" size="mini" :disabled="areYouSure" @click="confirmItinerary"
                style="margin-right: 0.3rem;" class="main_btn">{{ detection ? '确认行程' : '确认行程并下单' }} </el-button>
            <!-- <el-button type="primary" size="mini" :disabled="!areYouSure" @click="confirmSubmission" class="main_btn"
                    :class="areYouSure ? 'active' : 'active1'">确认提交</el-button> -->
        </div>
    </el-dialog>
</template>

<script>
import OrderApi from '@/components/Api/order'
import {dateFormatHm} from "@/assets/utils/unit";
export default {
    components: {},
    props: {
        detection: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            budgetIds: [],
            loading: false,
            pickerOptions: {
                start: '00:00', // 可选的开始时间
                end: '23:59', // 可选的结束时间
                step: '01:00' // 时间间隔
            },
            dialogVisible: false,
            areYouSure: false,
            radio: 0,
            maintenanceData: {},//维护的数据
            selectType: {
                0: '地址',
                1: '酒店名称或地址',
                2: '景点名称或地址',
                4: '餐厅名称或地址',
            },
            dataArr: [],//渲染的数据
            btnType: [
                {
                    name: '接',
                    code: 0
                },
                {
                    name: '送',
                    code: 2
                },
                {
                    name: '途',
                    code: 1
                }
            ],
            initOtherData: {}
        }
    },
    computed: {},
    methods: {
        selectTime(time,date,item) {
            if(time) {
                item.startTime = date + ' ' + time
            }else {
                item.startTime = ''
            }
        },
        editPlan(item) {
            let obj = JSON.parse(JSON.stringify(item))
            obj.startTime = dateFormatHm(obj.startTime)
            this.radio = item.mode
            this.initOtherData[item.mode] = []
            this.initOtherData[item.mode].push(obj)
        },
        dialogClose() {
            this.popoverClose()
        },
        //初始化
        initClick(ids) {
            this.budgetIds = ids
            this.dialogVisible = true
            if (!this.detection) {
                this.getData()
            } else {
                this.getViewData()
            }
        },
        getData() {
            this.loading = true
            new OrderApi("order").querySurePlan(this.budgetIds).then(res => {
                if (res.status === 200) {
                    this.dataArr = res.data
                    this.dataArr.forEach(items => {
                        items.planDate = items.orderSurePlanResultList[0].planDate
                        items.orderSurePlanResultList.forEach(item => {
                            item.giveList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            item.meetList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            item.tuList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            this.$set(item, 'visible', false)
                            item.budgetDetail.stockDetail = JSON.parse(item.budgetDetail.stockDetail)
                        })
                    })
                    this.loading = false
                    console.log(this.dataArr, '看看渲染的数据');
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        getViewData() {
            this.loading = true
            new OrderApi("order").querySurePlanByOrderMainId(this.budgetIds).then(res => {
                if (res.status === 200) {
                    this.dataArr = res.data
                    this.dataArr.forEach(items => {
                        items.planDate = items.orderSurePlanResultList[0].planDate
                        items.orderSurePlanResultList.forEach(item => {
                            item.giveList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            item.meetList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            item.tuList.forEach(n => n.budgetId = item.budgetDetail.budgetId)
                            this.$set(item, 'visible', false)
                            item.budgetDetail.stockDetail = JSON.parse(item.budgetDetail.stockDetail)
                        })
                    })
                    this.loading = false
                    console.log(this.dataArr, '看看渲染的数据');
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        //维护
        maintenance(items) {
            console.log(items, '看看维护的数据');
            this.popoverClose()
            this.radio = 0
            this.initOtherData = {
                '0': [
                    {
                        "budgetDetailId": items.budgetDetail.id,
                        "budgetId": items.budgetDetail.budgetId,
                        "budgetMainId": items.budgetDetail.budget.budgetMainId,
                        "del": false,
                        "endTime": "",
                        "id": null,
                        "mode": 0,
                        "remark": "",
                        "resourceNameCn": "",
                        "resourceNameEn": "",
                        "rid": null,
                        "startTime": ""
                    },
                ],
                '2': [
                    {
                        "budgetDetailId": items.budgetDetail.id,
                        "budgetId": items.budgetDetail.budgetId,
                        "budgetMainId": items.budgetDetail.budget.budgetMainId,
                        "del": false,
                        "endTime": "",
                        "id": null,
                        "mode": 0,
                        "remark": "",
                        "resourceNameCn": "",
                        "resourceNameEn": "",
                        "rid": null,
                        "startTime": ""
                    },
                ],
                '15': [
                    {
                        "budgetDetailId": items.budgetDetail.id,
                        "budgetId": items.budgetDetail.budgetId,
                        "budgetMainId": items.budgetDetail.budget.budgetMainId,
                        "del": false,
                        "endTime": "",
                        "id": null,
                        "mode": 0,
                        "remark": "",
                        "resourceNameCn": "",
                        "resourceNameEn": "",
                        "rid": null,
                        "startTime": ""
                    },
                ],
                '4': [
                    {
                        "budgetDetailId": items.budgetDetail.id,
                        "budgetId": items.budgetDetail.budgetId,
                        "budgetMainId": items.budgetDetail.budget.budgetMainId,
                        "del": false,
                        "endTime": "",
                        "id": null,
                        "mode": 0,
                        "remark": "",
                        "resourceNameCn": "",
                        "resourceNameEn": "",
                        "rid": null,
                        "startTime": ""
                    },
                ]
            }
            this.$set(items, 'visible', true)
            this.maintenanceData = items
        },
        closePopover(item) {
            this.$set(item, 'visible', false)
        },
        //切换
        handlerSwClick(n, code) {
            this.$set(n, 'mode', code)
        },
        //添加行程轴外的
        addOther() {
            let obj = {
                "budgetDetailId": this.maintenanceData.budgetDetail.id,
                "budgetId": this.maintenanceData.budgetDetail.budgetId,
                "budgetMainId": this.maintenanceData.budgetDetail.budget.budgetMainId,
                "del": false,
                "endTime": "",
                "id": null,
                "mode": 0,
                "remark": "",
                "resourceNameCn": "",
                "resourceNameEn": "",
                "rid": null,
                "startTime": ""
            }

            console.log(obj,'添加的数据')
            this.initOtherData[this.radio].push(obj)
            this.$message({
                type: 'success',
                message: '添加成功!'
            });
        },
        //删除行程外的
        delOther(index) {
            this.$confirm('您确定删除吗?, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$delete(this.initOtherData[this.radio], index)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            })
        },
        //维护保存
        save() {
            this.$confirm('您确定保存吗?, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let maintenanceData = JSON.parse(JSON.stringify(this.maintenanceData))
                let obj = JSON.parse(JSON.stringify(this.initOtherData))
                let arr = []
                //过滤没有填写resourceNameCn的对象
                for (const key in obj) {
                    obj[key] = obj[key].filter(item => item.resourceNameCn)
                    arr.push(...obj[key])
                }
                let planSureList = []
                planSureList = [...planSureList, ...maintenanceData.giveList, ...maintenanceData.meetList, ...maintenanceData.tuList, ...arr]
                new OrderApi("order").surePlanAddOrUpdate({ planSureList }).then(res => {
                    if (res.status === 200) {
                        this.loading = false
                        this.maintenanceData.visible = false
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        });
                        this.getData()
                    } else {
                        this.loading = false
                        this.$message.error(res.statusText)
                    }
                })
            })
        },
        //确认行程
        confirmItinerary() {
            if (this.detection) {
                this.dialogVisible = false
            } else {
                this.$confirm('您是否确认行程并下单?, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('confirmed')
                    this.dialogVisible = false
                })
            }

        },
        //确认提交
        confirmSubmission() {
            alert('确认提交')
        },
        popoverClose() {
            this.$refs.popoverRef.forEach(el => {
                el.doClose();
            })
        },
    },
    created() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog {
    background-color: #F2F2F2 !important;
    margin-top: 15vh !important;
}

/deep/ .el-dialog__body {
    display: flex;
    flex-direction: column;
    height: 85vh !important;
}

/deep/ .el-radio {
    margin-right: 0.1rem !important;
}

.active {
    background-color: rgba(102, 128, 244, 1) !important;
}

.active1 {
    background-color: rgba(191, 191, 191, 1) !important;
}

.active2 {
    background-color: rgba(252, 202, 0, 1) !important;
}



.detail_list_b_r_yuan {
    width: 0.25rem;
    height: 0.25rem;
    line-height: 0.25rem;
    border-radius: 50%;
    background-color: rgba(252, 202, 0, 1);
    color: #fff;
    font-size: 0.18rem;
    text-align: center;
    margin-right: 0.05rem;
    cursor: pointer;
}

.detail_list_b_r_p1 {
    margin-right: 0.07rem;
    color: rgba(219, 78, 26, 0.79);
    font-size: 0.16rem;
}

.edit {
    padding: 0.05rem 0;
    position: relative;

    .edit_prompt {
        display: flex;
        align-items: center;
        margin-bottom: 0.15rem;

        .edit_prompt_p1 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.16rem;
            font-weight: bold;
            margin-right: 0.05rem;
        }

        .edit_prompt_p2 {
            color: rgba(207, 19, 34, 1);
            font-size: 0.12rem;
        }
    }

    .edit_detail {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        margin-bottom: 0.1rem;

        .detail_list_b_block {
            display: flex;
            align-items: center;
            margin-bottom: 0.05rem;
        }

        // .detail_list_b_r_jie {
        //     display: flex;
        //     align-items: center;
        // }

        // .detail_list_b_r_song {
        //     display: flex;
        //     align-items: center;
        // }
    }

    .edit_other {
        display: flex;
        align-items: center;
        margin-bottom: 0.1rem;

        .edit_other_p1 {
            margin-right: 0.1rem;
            color: rgba(0, 0, 0, 1);
            font-size: 0.16rem;
        }
    }

    .edit_other_detail {
        border-radius: 5px;
        background-color: rgba(242, 242, 242, 1);
        padding: 0.1rem 0.05rem;
        margin-bottom: 0.18rem;
        position: relative;

        &:nth-last-child(1) {
            margin-bottom: 0;
        }

        .edit_other_detail_del {
            color: #CB582E;
            font-size: 0.2rem;
            position: absolute;
            top: -0.1rem;
            right: -0.05rem;
            z-index: 10;
            cursor: pointer;
        }

        .edit_other_detail_t {
            display: flex;
            align-items: center;
            margin-bottom: 0.1rem;

            .edit_other_detail_t_yuan_box {
                display: flex;
                align-items: center;

                .edit_other_detail_t_yuan {
                    width: 0.25rem;
                    height: 0.25rem;
                    line-height: 0.25rem;
                    border-radius: 50%;
                    background-color: rgba(252, 202, 0, 1);
                    color: #fff;
                    font-size: 0.18rem;
                    text-align: center;
                    margin-right: 0.02rem;
                    cursor: pointer;
                }
            }
        }

        .edit_other_detail_b {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .edit_other_detail_b_l {
                display: flex;
                align-items: center;

                .edit_other_detail_b_l_div {
                    color: rgba(16, 16, 16, 1);
                    font-size: 0.15rem;
                    text-align: center;
                    margin-right: 0.05rem;
                }
            }


        }
    }
}



.main_btn_box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.2rem;

    .main_btn {
        width: 1.7rem;
        height: 0.37rem;
        color: #fff;
        font-size: 0.18rem;
        text-align: center;
        border: none;
    }
}

.main {
    flex: 1;
    overflow-y: scroll !important;


    .title {
        font-size: 0.16rem;
        color: #333;
        font-weight: bold;
        margin: 0.15rem 0 0.05rem 0;
    }

    .detail {
        .detail_box {
            margin-bottom: 0.2rem;

            .data {
                display: flex;
                align-items: center;
                margin-bottom: 0.1rem;

                .data_p1 {
                    margin-left: 0.1rem;
                    color: rgba(0, 0, 0, 1);
                    font-size: 0.16rem;
                    font-weight: bold;
                }

                .data_p2 {
                    width: 0.35rem;
                    height: 0.35rem;
                    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACUklEQVRYR+2Xy2vUUBTGv3NnyhSlUrSVJOMjxZV20UL/gSkW7KRV3Lh2Vt0LdW3Fre6tG3Wj0KXTTkpRO3sf4EaKVDqMTjKtKCoo83ByJKHJvEp7pwSmi7kQuLm533d+OfcmOSF0uVGX4+NAgC/TSqLP4TfK2vYfWdiNa0MDxyvRCRndvgDWjDoHxqLDPH/GLD6QBfhqKCkBeiyj2xegYCgLBLrD4LvxTHFBFqATXRvA1nV9MFoqjbvBhMBNAqUY/MRx8FQWYC/dMaq8P2X++N3q0QRgGdoSwDdkA3U6j8DpKju3zpk7n31tAGAZKgeGjOxuXwdBByMHeIdsa9cREr6YBc7Hl+28e+4BWEl1EYQ5d62JKK2t2O/c8U7WspFsL509reiOQMrdUwCtaBlrtg5gqDsAhol5VDWLH32zb1eG1Kroe8ZEj+IZ67ns7duzisE1ut2qcx/piKB1L7DDI+pqMUfBICOrmfakbJDDzrOS6joIiZrDk2dXi9kAgEEfQJg/rLG0jnGfwGNtANIGIU30X1L1JQD9BHiwwf9lSLF8m6ndjuO+Yir/nMv62vbro7MH0O1N2APoZaCXgV4GupaB78mTJ8oU+9X4jQ75GxDYWTPqBBhvvYEIXdTS1oZXEdmG8oJBV1srojBBmisifCr/jY2NZHMlDyCfPH0hSpHNIGC9JgyPoaEmFEJMKcuFV0FJ5mUhqVyCoCVmjIYXtdmJiC1muqdl7If+laayfCuh98cGKnqt6ihhQ8Si0cJwrT9P5ma50fvAf8OwQVr9ug7wH/8HmjAEHOudAAAAAElFTkSuQmCC) no-repeat;
                    background-size: 0.35rem 0.35rem;
                    font-weight: bold;
                    color: #db4e1a;
                    text-align: center;
                    line-height: 0.45rem;
                    font-size: 0.12rem;
                }
            }

            .detail_list {
                position: relative;
                padding-top: 0.28rem;
                margin-bottom: 0.2rem;

                &:nth-last-child(1) {
                    margin-bottom: 0;
                }

                .detail_list_t {
                    top: 0;
                    right: 0;
                    width: 100%;
                    position: absolute;
                    padding: 0.1rem;
                    height: 0.3rem;
                    background-color: rgba(255, 255, 255, 1);
                    text-align: center;
                    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
                    font-size: 0.16rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .detail_list_t_p1 {
                        color: rgba(219, 78, 26, 0.79);
                        font-size: 0.16rem;
                        font-family: SourceHanSansSC-regular;

                    }

                    .detail_list_t_p2 {
                        color: rgba(230, 74, 25, 1);
                        font-size: 0.16rem;
                        font-weight: bold;
                    }

                    .detail_list_t_p3 {
                        width: 1.4rem;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        cursor: pointer;
                    }
                }

                .detail_list_b {
                    padding: 0.15rem 0.1rem;
                    border: 1px dotted rgba(187, 187, 187, 1);
                    background-color: #fff;
                    display: flex;

                    .detail_list_b_l {
                        display: flex;
                        align-items: center;
                        margin-right: 0.3rem;

                        .detail_list_b_l_p1 {
                            color: rgba(16, 16, 16, 1);
                            font-size: 0.16rem;
                            font-weight: bold;
                            margin-right: 0.1rem;
                        }

                        .detail_list_b_l_span1 {
                            color: rgba(207, 19, 34, 1);
                            font-size: 0.14rem;
                            text-decoration: underline;
                            cursor: pointer;
                        }
                    }

                    .detail_list_b_r {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        flex: 1;

                        .detail_list_b_block {
                            display: flex;
                            align-items: center;
                            margin-bottom: 0.05rem;
                        }
                    }

                }

            }
        }
    }
}
</style>